/*
  Better existential check. Shamelessly stolen from coffeescript.
*/

export default val => typeof val !== 'undefined' && val !== null;
